import React from 'react';
import { useSelector } from 'react-redux';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { selectIsSellerPaidFieldsVisible } from 'store/loanApplications/selectors';

const RecordingFeeTableHead = () => {
  const isSellerPaidFieldsVisible = useSelector(selectIsSellerPaidFieldsVisible);

  return (
    <TableHead>
      <TableRow>
        <TableCell>Recording Type</TableCell>
        <TableCell>Fee</TableCell>
        <TableCell colSpan={2} />
        {isSellerPaidFieldsVisible && <TableCell colSpan={2} />}
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
};

export default RecordingFeeTableHead;
